import React, { Suspense, lazy } from 'react';
import { useCalculatorStore } from '../../store/calculatorStore';
import { MortgageCalculator } from './MortgageCalculator';

const ComparisonView = lazy(() => import('./ComparisonView').then((m) => ({ default: m.ComparisonView })));

interface CalculatorTabsProps {
  onAddScenario: () => void;
  hasScenario2: boolean;
}

export const CalculatorTabs: React.FC<CalculatorTabsProps> = ({ onAddScenario, hasScenario2 }) => {
  const calculatorTabs = useCalculatorStore(s => s.calculatorTabs);
  const activeTabId = useCalculatorStore(s => s.activeTabId);

  if (activeTabId === 'compare') {
    return (
      <Suspense
        fallback={
          <div className="p-8 text-center text-ink-muted text-sm" role="status">
            Loading comparison…
          </div>
        }
      >
        <ComparisonView />
      </Suspense>
    );
  }

  const activeTab = calculatorTabs.find(tab => tab.id === activeTabId);

  if (!activeTab) {
    return <div className="p-6 text-center text-ink-muted">No calculator selected</div>;
  }

  return (
    <MortgageCalculator
      tabId={activeTab.id}
      onAddScenario={onAddScenario}
      hasScenario2={hasScenario2}
    />
  );
};
